/* ==========================================================
   בלוק הטאבים במוצר – תוספות שאין בבלוק עצמו (משלים את
   assets/claude-product-tabs.css):
   - עיגול עם האות הראשונה של שם הכותב בטאב "ביקורת מקצועית".
   - תג "ביקורת מומחה" בשורת הכוכבים.
   - הכמות בטאב "הוראות הכנה" עטופה בגלולה.
   הפעולות אידמפוטנטיות.
   ========================================================== */
(function () {
  'use strict';

  function enhance() {
    document.querySelectorAll('[class*="product-tabs-container-"]').forEach(function (root) {
      var author = root.querySelector('.tab-author');
      var name = root.querySelector('.author-name');
      if (author && name && !author.querySelector('.pt-initial')) {
        var initial = document.createElement('span');
        initial.className = 'pt-initial';
        initial.setAttribute('aria-hidden', 'true');
        initial.textContent = name.textContent.trim().charAt(0);
        author.insertBefore(initial, author.firstChild);
      }

      var stars = root.querySelector('.tab1-star-rating');
      if (stars && !stars.querySelector('.pt-expert')) {
        var tag = document.createElement('span');
        tag.className = 'pt-expert';
        tag.textContent = 'ביקורת מומחה';
        stars.appendChild(tag);
      }

      root.querySelectorAll('.directions-row > .directions-col-dosage').forEach(function (cell) {
        if (cell.querySelector('.pt-pill') || !cell.textContent.trim()) return;
        var pill = document.createElement('span');
        pill.className = 'pt-pill';
        pill.textContent = cell.textContent.trim();
        cell.textContent = '';
        cell.appendChild(pill);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance);
  } else {
    enhance();
  }
  document.addEventListener('shopify:section:load', enhance);
})();
